import { useState } from "react"
import { PageHeader } from "~/ui/PageHeader"
import { organizationCandidateTestUnlockRequestsPath } from "~/common/paths"
import { CandidateTestUnlockRequestSortEnum } from "~/__generated__/graphql"
import { useParams } from "react-router-dom"
import invariant from "tiny-invariant"

import {
  CandidateTestUnlockRequestsTableTopFilter,
  UnlockRequestFilter,
} from "~/tests/CandidateTestUnlockRequestsTableFilter"
import { CandidateTestUnlockRequests } from "~/tests/CandidateTestUnlockRequests"

export const OrganizationCandidateTestUnlockRequestsScreen = () => {
  const { organizationId } = useParams()
  invariant(organizationId)

  const [filter, setFilter] = useState<UnlockRequestFilter>({
    unlockRequestStates: [],
    query: null,
  })

  return (
    <div className="container mx-auto flex flex-col gap-8 mt-8 pb-12">
      <PageHeader
        title="Candidate Requests"
        subhead="Candidates requesting to continue their assessment"
      />
      <CandidateTestUnlockRequestsTableTopFilter
        filter={filter}
        onFilterChange={setFilter}
      />
      <CandidateTestUnlockRequests
        columns={["candidate", "testName", "reason", "createdAt", "actions"]}
        defaultSort={CandidateTestUnlockRequestSortEnum.CreatedAt}
        organizationId={organizationId}
        filter={filter}
        viewPath={() =>
          organizationCandidateTestUnlockRequestsPath({
            organizationId,
          })
        }
      />
    </div>
  )
}
